"use client";
import React from "react";

export default function FooterNewsletter({data}) {
    const {
        logo,
        description,
        newsletter = {},
        columns = [],
        bottom = {},
        background = {},
        socials = []
    } = data || {};

    const bgStyle =
        background.type === "color"
            ? {backgroundColor: background.value}
            : background.type === "gradient"
                ? {backgroundImage: background.value}
                : background.type === "image"
                    ? {
                        backgroundImage: `url(${background.value})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center"
                    }
                    : {};

    return (
        <footer className="text-sm text-gray-400 pt-12" style={bgStyle}>
            <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 md:grid-cols-3 gap-8">
                <div>
                    {logo?.src && (
                        <a href={logo.href || "/"} className="inline-block mb-4">
                            <img src={logo.src} alt={logo.alt || "Logo"} className="h-8"/>
                        </a>
                    )}
                    {description && <p className="text-gray-400">{description}</p>}
                    {socials?.length > 0 && (
                        <div className="flex gap-4 mt-4">
                            {socials.map((social, i) => (
                                <a key={i} href={social.href} target="_blank" rel="noopener noreferrer">
                                    <span className="text-xl">{social.icon}</span>
                                </a>
                            ))}
                        </div>
                    )}
                </div>

                {columns.map((col, i) => (
                    <div key={i}>
                        <h4 className="text-white font-semibold mb-3">{col.title}</h4>
                        <ul className="space-y-2">
                            {col.links?.map((link, j) => (
                                <li key={j}>
                                    <a href={link.href} className="hover:text-white transition">
                                        {link.label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}

                {newsletter?.enabled && (
                    <div className="md:col-span-1">
                        <h4 className="text-white font-semibold mb-3">{newsletter.title || "Subscribe"}</h4>
                        <form onSubmit={(e) => e.preventDefault()} className="flex flex-col gap-3">
                            <input
                                type="email"
                                placeholder={newsletter.placeholder || "Enter your email"}
                                className="px-4 py-2 rounded-md bg-gray-800 text-white border border-gray-600 focus:outline-none"
                            />
                            <button
                                type="submit"
                                className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition"
                            >
                                {newsletter.buttonText || "Subscribe"}
                            </button>
                        </form>
                    </div>
                )}
            </div>

            <div className="border-t border-gray-700 mt-10 py-6 px-4 text-center">
                <p>{bottom?.text || "© 2025 Webfity. All rights reserved."}</p>
                {bottom?.links?.length > 0 && (
                    <div className="flex flex-wrap justify-center gap-4 mt-2">
                        {bottom.links.map((link, i) => (
                            <a key={i} href={link.href} className="hover:text-white">
                                {link.label}
                            </a>
                        ))}
                    </div>
                )}
            </div>
        </footer>
    );
}